import { render } from "./Certificates.vue?vue&type=template&id=e2ef11cc&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"

import "./Certificates.vue?vue&type=style&index=0&id=e2ef11cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2ef11cc"]])

export default __exports__